import { observable, computed, makeObservable } from 'mobx'
import constants, { selectionTypes } from 'constants.js'

// User-specific information
class User {
  @observable email
  @observable accountStatus
  @observable number_of_licenses
  @observable plan = { name: '', descr: '', type: '', days_due: '', subscr: { status: 0, canceled: false, expires: null, expired: false } }

  constructor ({
    id,
    type,
    email,
    accountStatus,
    number_of_licenses,
    plan,
    limits,
    limitErrorMessage,
    is_advertise_popup_visible,
    is_first_login,
    needs_recalculation,
    user_api_token,
    region_limit_locked
  }) {
    makeObservable(this)
    this.id = id
    this.type = type
    this.email = email
    this.accountStatus = accountStatus
    this.number_of_licenses = number_of_licenses
    this.plan = plan
    this.limits = limits
    this.limitErrorMessage = limitErrorMessage
    this.is_advertise_popup_visible = is_advertise_popup_visible
    this.is_first_login = is_first_login
    this.needs_recalculation = needs_recalculation
    this.user_api_token = user_api_token
    this.region_limit_locked = region_limit_locked
    this.setupHeap()
  }

  // Give Heap analytics some more info about this user
  setupHeap () {
    if (!window.heap) return
    // Stable identity = user_id (immutable). Email can change, so it stays a property.
    if (window.heap.identify && this.id) {
      window.heap.identify(String(this.id))
    }
    if (window.heap.addUserProperties) {
      window.heap.addUserProperties({
        email: this.email,
        internal: /@kimetrica.com$/g.test(this.email) ||
        /@populationexplorer.com$/g.test(this.email),
        trial: this.trial,
        group: this.number_of_licenses > 1
      })
    }
  }

  @computed get canShare () {
    return this.number_of_licenses && this.number_of_licenses > 1
  }

  @computed get trial () {
    return this.accountStatus === constants.TRIAL_STATUS
  }

  @computed get isStarter () {
    return this.type === 'starter'
  }

  @computed get isPro () {
    // Treat any non-starter, non-trial plan as Pro
    return !this.trial && !this.isStarter
  }

  get selection () {
    return {
      item: this,
      type: selectionTypes.USER
    }
  }
}

export default User
